import { put, call, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { FaqType } from 'domain/types/faq.type';
import { fetchFaqsSuccessAction, fetchFaqsFailureAction, insertFaqSuccessAction, insertFaqFailureAction, updateFaqSuccessAction, updateFaqFailureAction } from 'domain/actions/faq.action';
import { showLoading, hideLoading } from 'domain/actions/loading.action';
import { getFaqs, insertFaq, updateFaq } from 'service/faq/faq.service';
import { FaqResponse } from 'model/faq/faq.response';
import { FaqRequestParams, FaqInsertRequest, FaqUpdateRequest } from 'model/faq/faq.request';

/**
 * Saga worker function to fetch FAQs
 */
function* fetchFaqsSaga(action: any): SagaIterator {
  try {
    // Show loading indicator
    yield put(showLoading());
    
    // Get params from action payload
    const params: FaqRequestParams = action.payload.params;
    
    // Call the API service
    const response: FaqResponse = yield call(getFaqs, params);
    
    // Dispatch success action with the fetched FAQs
    yield put(fetchFaqsSuccessAction(response));
  } catch (error: any) {
    // Dispatch failure action with the error message
    yield put(fetchFaqsFailureAction(error?.message || 'Failed to fetch FAQs'));
  } finally {
    // Hide loading indicator
    yield put(hideLoading());
  }
}

/**
 * FAQ saga watcher
 */
function* insertFaqSaga(action: any): SagaIterator {
  try {
    yield put(showLoading());
    const params: FaqInsertRequest = action.payload.params;
    const response: any = yield call(insertFaq, params);
    yield put(insertFaqSuccessAction(response));
  } catch (error: any) {
    yield put(insertFaqFailureAction(error?.message || 'Failed to insert FAQ'));
  } finally {
    yield put(hideLoading());
  }
}

function* updateFaqSaga(action: any): SagaIterator {
  try {
    yield put(showLoading());
    const params: FaqUpdateRequest = action.payload.params;
    const response: any = yield call(updateFaq, params);
    yield put(updateFaqSuccessAction(response));
  } catch (error: any) {
    yield put(updateFaqFailureAction(error?.message || 'Failed to update FAQ'));
  } finally {
    yield put(hideLoading());
  }
}

export function* faqSaga(): SagaIterator {
  yield takeLatest(FaqType.FETCH_FAQS_REQUEST, fetchFaqsSaga);
  yield takeLatest(FaqType.INSERT_FAQ_REQUEST, insertFaqSaga);
  yield takeLatest(FaqType.UPDATE_FAQ_REQUEST, updateFaqSaga);
}